import { useState, useCallback } from 'react';

let toastIdCounter = 0;

export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', duration = 5000, action = null) => {
    const id = ++toastIdCounter;
    const toast = { id, message, type, duration, action };
    
    setToasts((prev) => [...prev, toast]);
    
    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const success = useCallback((message, duration, action) => {
    return showToast(message, 'success', duration, action);
  }, [showToast]);

  const error = useCallback((message, duration, action) => {
    return showToast(message, 'error', duration, action);
  }, [showToast]);

  const warning = useCallback((message, duration, action) => {
    return showToast(message, 'warning', duration, action);
  }, [showToast]);

  const info = useCallback((message, duration, action) => {
    return showToast(message, 'info', duration, action);
  }, [showToast]);

  return {
    toasts,
    showToast,
    removeToast,
    success,
    error,
    warning,
    info,
  };
};











